let loadStatus = 1;
let frenzyBrandLink = '#';
var enable_new_arrivals = $('html').attr('badge_enable');
function getNewYorkTime() {
    let systemTime = new Date();
    let options = {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
    };
    let newYorkTime = new Intl.DateTimeFormat('en-US', options).format(systemTime);
   return newYorkTime;
}
 
  var system_date = new Date(getNewYorkTime());
  
  var pdpbadge = 0;
window.frenzyQuickViewProductCallBack = function(data){
  if(__st && __st.p == "product"){
    (data ||[]).map((item,index)=>{
      frenzy_recommendation_loaded(item);
    })
  }
}
window.FrenzyProductGridChangeCallBack = async function(html, data){
  // if(enable_new_arrivals == 'false'){
  // console.log('enable_new_arrivals');
  // console.log(enable_new_arrivals);
  // }
  var count = 0;
  var promo = 0;
  var new_arrivalsclothingfound = 0;
  var collection_promo = 0;
  $('.collection__badges').each(function(index){ 
  var badge_message = $(this).attr('data-message');
  var badge_tags = $(this).attr('data-tags');
  var badge_bgcolor = $(this).attr('data-background');
  var badge_color = $(this).attr('data-color');
  if(badge_tags != ''){
    badge_tags = badge_tags.split(',')
  }
  var badge_start = $(this).attr('data-start');
  var badge_end = $(this).attr('data-end');
    var startDate = new Date(badge_start);
    var endDate = new Date(badge_end);
   
    var Difference_In_Time_start = parseInt(system_date.getTime() - startDate.getTime());
    // console.log(Difference_In_Time_start);
    var Difference_In_Time_end =   parseInt(endDate.getTime() - system_date.getTime());
    if(Difference_In_Time_start >= 0 && badge_start != ''){
     if(Difference_In_Time_end >= 0 && badge_end != ''){
    for(var i=0; i<badge_tags.length;i++){
      if(data.org_product_tags.includes(badge_tags[i]) && count ==0){
        count++;
        var badge_htm = `<div class="badge__cstm" style="--bgcolor:${badge_bgcolor};--color:${badge_color}">${badge_message}</div>`;
         html.querySelector('.frenzy_product_item a').insertAdjacentHTML("beforeend",badge_htm);
        break;
      }
    }
    }
    }
    });
// tag based promo
   $('.collection__promotion').each(function(index){ 
  var promo_message = $(this).attr('data-message');
  var promo_tags = $(this).attr('data-tags');
  var promo_bgcolor = $(this).attr('data-background');
  var promo_color = $(this).attr('data-color');
  if(promo_tags != ''){
    promo_tags = promo_tags.split(',')
  }
  var promo_start = $(this).attr('data-start');
  var promo_end = $(this).attr('data-end');
    //var system_date = new Date();
    // console.log(system_date);
    var startDate_promo = new Date(promo_start);
    var endDate_promo = new Date(promo_end);
    var Difference_In_Time_start_promo = parseInt(system_date.getTime() - startDate_promo.getTime());
    var Difference_In_Time_end_promo =   parseInt(endDate_promo.getTime() - system_date.getTime());
    // console.log(Difference_In_Time_start_promo);
    // console.log(promo_start);
    //  console.log(Difference_In_Time_end_promo);
    //  console.log(promo_end);
    if(Difference_In_Time_start_promo >= 0 && promo_start != ''){
     if(Difference_In_Time_end_promo >= 0 && promo_end != ''){
    for(var i=0; i<promo_tags.length;i++){
       if(enable_new_arrivals == 'false'){
    //    show for clothing new arrivals 
         if(data.org_product_tags.includes('Everyday Value,Occasion') || data.org_product_tags.includes('Occasion:SEPARATES') || data.org_product_tags.includes('Brand:SHUG BY ADRIANNA PAPELL')){
          promo++;
          var badge_htm = `<div class="promo__cstm" style="--bgcolor:${promo_bgcolor};--color:${promo_color}">${promo_message}</div>`;
         html.querySelector('.promo_message').insertAdjacentHTML("beforeend",badge_htm);
        break;
        }
        //  End  show for clothing new arrivals 

     if(data.org_product_tags.includes(promo_tags[i]) && promo ==0 && !data.org_product_tags.includes('New Arrival')){
       promo++;
         // console.log(promo_tags[i]);
        var badge_htm = `<div class="promo__cstm" style="--bgcolor:${promo_bgcolor};--color:${promo_color}">${promo_message}</div>`;
         html.querySelector('.promo_message').insertAdjacentHTML("beforeend",badge_htm);
        break;
    }
       }else{
        if(data.org_product_tags.includes('Everyday Value,Occasion') || data.org_product_tags.includes('Occasion:SEPARATES') || data.org_product_tags.includes('Brand:SHUG BY ADRIANNA PAPELL')){
          new_arrivalsclothingfound++;
        } 
         if(data.org_product_tags.includes(promo_tags[i]) && promo ==0 && new_arrivalsclothingfound > 0 && data.org_product_tags.includes('New Arrival')){
           promo++;
         // console.log(promo_tags[i]);
        var badge_htm = `<div class="promo__cstm" style="--bgcolor:${promo_bgcolor};--color:${promo_color}">${promo_message}</div>`;
         html.querySelector('.promo_message').insertAdjacentHTML("beforeend",badge_htm);
        break;
         }
         else{
      if(data.org_product_tags.includes(promo_tags[i]) && promo ==0 && !data.org_product_tags.includes('New Arrival')){
        promo++;
         // console.log(promo_tags[i]);
        var badge_htm = `<div class="promo__cstm" style="--bgcolor:${promo_bgcolor};--color:${promo_color}">${promo_message}</div>`;
         html.querySelector('.promo_message').insertAdjacentHTML("beforeend",badge_htm);
        break;
      }
       }
       }
    }
    }
    }
    });
// End tag based promo
  // only for collection handle based promo message 
  if(promo == 0){
  $('.collection_page__promotion').each(function(index){ 
  var collection_promo_message = $(this).attr('data-message');
  var collection_promo_tags = $(this).attr('data-tags');
  var collection_promo_bgcolor = $(this).attr('data-background');
  var collection_promo_color = $(this).attr('data-color');
  var promo_handle = $(this).attr('data-handle');
  if(collection_promo_tags != ''){
    collection_promo_tags = collection_promo_tags.split(',')
  }
  var collection_promo_start = $(this).attr('data-start');
  var collection_promo_end = $(this).attr('data-end');
    // var system_date = new Date();
    var collection_startDate_promo = new Date(collection_promo_start);
    var collection_endDate_promo = new Date(collection_promo_end);
    var collection_Difference_In_Time_start_promo = parseInt(system_date.getTime() - collection_startDate_promo.getTime());
    var collection_Difference_In_Time_end_promo =   parseInt(collection_endDate_promo.getTime() - system_date.getTime());
    if(collection_Difference_In_Time_start_promo >= 0 && collection_promo_start != ''){
     if(collection_Difference_In_Time_end_promo >= 0 && collection_promo_end != ''){
        if(enable_new_arrivals == 'false'){
     if(collection_promo_tags.includes(promo_handle) && collection_promo ==0  && !data.org_product_tags.includes('New Arrival')){
       collection_promo++;
        var badge_htm = `<div class="promo__cstm" style="--bgcolor:${collection_promo_bgcolor};--color:${collection_promo_color}">${collection_promo_message}</div>`;
         html.querySelector('.promo_message').insertAdjacentHTML("beforeend",badge_htm);
     }
        }else{
      if(collection_promo_tags.includes(promo_handle) && collection_promo ==0){
        collection_promo++;
        var badge_htm = `<div class="promo__cstm" style="--bgcolor:${collection_promo_bgcolor};--color:${collection_promo_color}">${collection_promo_message}</div>`;
         html.querySelector('.promo_message').insertAdjacentHTML("beforeend",badge_htm);
      }
        }
    }
    }
    });
  }
  // End only for collection handle based promo message 
   //console.log(data);
   

  // console.log(data.org_product_tags);
  //console.log(badges);

 
    if(data.org_price === 0){
      var priceDiv = html.querySelector(".frenzy_product_price_meta").classList;
      priceDiv.add("hidePrice");
    }

    if(data.st_tag_brand && data.st_tag_brand.includes("ADRIANNA PAPELL PLATINUM") ){
      var priceDiv = html.querySelector(".frenzy_product_price_meta").classList;
      priceDiv.add("hidePrice");
    }

  if(data.st_tag_brand !== null && Array.isArray(data.st_tag_brand) && data.st_tag_brand.length>0  ){
     if(data.st_tag_brand[0] == 'ADRIANNA PAPELL PLATINUM'){
       html.querySelector('.ssw-faveiticon').remove();
     }
      if(data.st_tag_brand[0] == 'ADRIANNA DAY'){
        frenzyBrandLink = '/collections/adrianna-day-dresses';
      }else if(data.st_tag_brand[0] == 'ADRIANNA EVENING'){
        frenzyBrandLink = '/collections/adrianna-evening-dresses';
      }else if(data.st_tag_brand[0] == 'ADRIANNA by Adrianna Papell'){
        frenzyBrandLink = '/collections/adrianna-by-adrianna-papell';
      }
      else if(data.st_tag_brand[0] == 'ADRIANNA PAPELL'){
        frenzyBrandLink = '/collections/brand-adrianna-papell';
      }
      else if(data.st_tag_brand[0] == 'AIDAN MATTOX'){
        frenzyBrandLink = '/collections/brand-aidan-mattox-by-adrianna-papell';
      }
      var st_tag_brand = html.querySelector(".card-vendor");
      st_tag_brand.innerHTML = '<a class="mobile-url" href="'+frenzyBrandLink+'" title="'+data.st_tag_brand[0]+'"><b>'+data.st_tag_brand[0]+'</b></a>';
      var st_retail_price = html.querySelector(".frenzy_st_retail_price");
      if(data?.org_product_tags.includes('Everyday Value') || data?.org_product_tags.includes('Category:SPORTSWEAR')){
       if(data.st_retail_price.length > 0 && data.st_retail_price[0] > data.org_price ){
          st_retail_price.innerHTML = ' Compare at '+money_format_Frenzy(data.st_retail_price[0], frenzy_shop_currency) ;
       }
      }
     
    }

  
  var revireData = null;
   if(data.smf_unite_review != undefined){
    data.smf_unite_review =  JSON.parse(data.smf_unite_review[0]);
     revireData = data.smf_unite_review;
  }else if(data.smf_review){
    data.smf_review =  JSON.parse(data.smf_review[0]);
    revireData = data.smf_review;
  }
  if(revireData!==null && revireData.count > 0){
    var floo_avg = Math.floor(revireData.avg);
    var iconreview ='';
    for(var i=1;i<=floo_avg;i++){
      iconreview += "<i class='ssw-icon-star'></i>";  
    }
    var ssw_rate_last_star = 5 - revireData.avg;
    var ssw_y = Math.floor(ssw_rate_last_star);
    var ssw_x = revireData.avg - floo_avg;
    var rclass = '';
    if(ssw_x > 0.74){
        iconreview += "<i class='ssw-icon-star'></i>";
    }
    else{
      if(ssw_x > 0.24){
         iconreview += "<i class='ssw-icon-star-half-alt'></i>";
      }else{
        if(ssw_x > 0){
             ssw_y = (ssw_y+1);
            // rclass= 'ssw-icon-star-empty';
        }
      }
    }
    for(var j=1;j<=ssw_y;j++){
           iconreview +='<i class="ssw-icon-star-empty"></i>';
    }
    var startHTML = '<div class="ssw-widget-avg-rate-listing ssw-stars ssw-stars-large " data-rate="'+revireData.avg+'" tabindex="0" aria-label="Review listing, rating is: '+revireData.avg+'">';
      startHTML += iconreview;
      startHTML += '<span class="ssw-review-count fff" tabindex="0" aria-label="'+revireData.count+'"> ('+revireData.count+') </span>';
    startHTML += '</div>';
   // html.querySelector('.frenzy_product_title').insertAdjacentHTML("beforeend",startHTML);
   //html.querySelector('.cstm__card__review').insertAdjacentHTML("beforeend",startHTML);
  }
   if(data.smf_badge != undefined){
  html.querySelector('.cstm__card__review').insertAdjacentHTML("beforeend",data.smf_badge[0]);
   }


  // swatch
   if(data.smf_swatchJSON){
     var swatchobj = data.smf_swatchJSON;
     var swatchHTML = '<div class="swatches_favorites"><ul class="swatches">';
    if(data.smf_styleNumber){
      if (Array.isArray(data.smf_styleNumber)){
        data.smf_styleNumber =  data.smf_styleNumber[0];
      }
      swatchobj.forEach(function(val,index){
        val = JSON.parse(val);
        var order = '';
        var swatch_checked = '';
        if(data.product_id == val.productID){
          order = 'style="order:-1"';
          // swatch_checked = 'checked';
          swatch_checked = 'active';
          // index = 0;
          index++;
        }
        else{
          index++;
          if(index <= 1){
            index = 1;  
          }
          
        }
          swatchHTML += '<li class="swatches__item frenzy_swatch '+swatch_checked+'" data-product-id="'+data.product_id_variant+'" '+order+'>';
            // swatchHTML += '<input type="radio" class="swatch_input" data-product-id-variant="'+data.product_id_variant+'" data-product-id="'+val.productID+'" id="card_swatches__radio'+data.smf_styleNumber+'_'+loadStatus+'_'+index+'" name="color_radio_'+data.product_id+'" value="'+val.colorName+'" '+swatch_checked+'>';
            // swatchHTML += '<label for="card_swatches__radio'+data.smf_styleNumber+'_'+loadStatus+'_'+index+'" title="'+val.colorName+'">';
            swatchHTML += '<input type="radio" class="swatch_input" data-product-id-variant="'+data.product_id_variant+'" data-product-id="'+val.productID+'" name="color_radio_'+data.product_id+'" value="'+val.colorName+'">';
            swatchHTML += '<label for="" title="'+val.colorName+'">';
              swatchHTML += '<img class="lazyload js color-image color-image--'+val.colorName+'"';
                swatchHTML += 'src="//www.adriannapapell.com/cdn/shop/t/585/assets/transparent1x1.png?v=3572747942675330941761297019"';
                swatchHTML += 'data-src="https://www.adriannapapell.com/cdn/shop/files/'+data.smf_styleNumber+'_'+val.colorCode+'_60x60_crop_center.jpg"';
                swatchHTML += 'alt="'+val.colorName+'"';
                swatchHTML += 'title="'+val.colorName+'"';
                swatchHTML += 'data-widths="[24, 50, 100]"';
                swatchHTML += 'data-sizes="auto"';
                swatchHTML += 'height="24"';
                swatchHTML += 'width="24">';
            swatchHTML += '</label>';
          swatchHTML += '</li>';   
      })
      swatchHTML += '</ul>';
      var SwatchCount = swatchobj.length;
      if(SwatchCount > 5){
         swatchHTML += '<div class="swatch-count" data-total="'+SwatchCount+'"';
            var colorText = 'color';
            // if(SwatchCount == 7){
            //   if((SwatchCount - 6) > 1){
            //     colorText = 'colors';
            //   }
            //   swatchHTML += ' data-six="+ ' +(SwatchCount - 6) +' '+colorText+'"';
            //   swatchHTML += 'data-six-mobile="+ '+(SwatchCount - 6)+'"';
            // }else if(SwatchCount > 6){
            //   if((SwatchCount - 6) > 1){
            //     colorText = 'colors';
            //   }
            //   swatchHTML += ' data-six="+ ' +(SwatchCount - 6) +' '+colorText+'"';
            //   swatchHTML += 'data-six-mobile="+ '+(SwatchCount - 6)+'"';
            // }
        
            if(SwatchCount >= 6){
              if((SwatchCount - 5) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-five="+ ' +(SwatchCount - 5) +' '+colorText+'"';
              swatchHTML += 'data-five-mobile="+ '+(SwatchCount - 5)+'"';
            }else if(SwatchCount > 5){
              if((SwatchCount - 5) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-five="+ ' +(SwatchCount - 5) +' '+colorText+'"';
              swatchHTML += 'data-five-mobile="+ '+(SwatchCount - 5)+'"';
            }
        
            if(SwatchCount == 5){
              if((SwatchCount - 4) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-four="+ ' +(SwatchCount - 4) +' '+colorText+'"';
              swatchHTML += 'data-four-mobile="+ '+(SwatchCount - 4)+'"';
            }else if(SwatchCount > 4){
              if((SwatchCount - 4) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-four="+ ' +(SwatchCount - 4) +' '+colorText+'"';
              swatchHTML += 'data-four-mobile="+ '+(SwatchCount - 4)+'"';
            }
    
            if(SwatchCount == 4){
              if((SwatchCount - 3) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-three="+ ' +(SwatchCount - 3) +' '+colorText+'"';
              swatchHTML += 'data-three-mobile="+ '+(SwatchCount - 3)+'"';
            }else if(SwatchCount > 3){
              if((SwatchCount - 3) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-three="+ ' +(SwatchCount - 3) +' '+colorText+'"';
              swatchHTML += 'data-three-mobile="+ '+(SwatchCount - 3)+'"';
            }
    
            if(SwatchCount == 3){
              if((SwatchCount - 2) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-two="+ ' +(SwatchCount - 2) +' '+colorText+'"';
              swatchHTML += 'data-two-mobile="+ '+(SwatchCount - 2)+'"';
            }else if(SwatchCount > 2){
              if((SwatchCount - 2) > 1){
                colorText = 'colors';
              }
              swatchHTML += ' data-two="+ ' +(SwatchCount - 2) +' '+colorText+'"';
              swatchHTML += 'data-two-mobile="+ '+(SwatchCount - 2)+'"';
            }
         swatchHTML += '></div>';
      }
    swatchHTML += '</div>';
     // html.querySelector('.frenzy_swatch_wrap').insertAdjacentHTML("beforebegin",swatchHTML);
     html.querySelector('.frenzy_swatch_wrap').innerHTML = swatchHTML;
    }
   }
  setTimeout(function(){
      if(document.querySelectorAll('.swatches__item.frenzy_swatch[data-product-id="'+ data.product_id_variant +'"'+']').length > 0){
        document.querySelectorAll('.swatches__item.frenzy_swatch[data-product-id="'+ data.product_id_variant +'"'+']').forEach(function(this_click){
          this_click.addEventListener('click', (event) => {
              document.querySelectorAll('.swatches__item.frenzy_swatch[data-product-id="'+ data.product_id_variant +'"'+']').forEach(function(oldSwatch){
                oldSwatch.classList.remove('active');
              });
              this_click.classList.add('active');
              // $(".product-card .frenzy_swatch").removeClass('active');
              FrenzyswatchQuery(this_click.querySelector('input').getAttribute('data-product-id'),this_click.closest('.frenzy_grid'));
          });
        });
      }
  },500)
  loadStatus++;
  const frenzy_var_id = data?.sku.split('_');
  const frenzy_sku = html.querySelector('figure a')?.dataset.sku;
  const frenzy_configID = html.querySelector('figure a')?.dataset.config_id;
  const frenzy_event_name = html.querySelector('figure a')?.dataset.name;
  const frenzy_request_ID = html.querySelector('figure a')?.dataset.request_id;
  if(data?.org_request_type == 'widget_cart_popup_carousel_config'){
    const quickviewbtn_html = `<div class="quick_view_cart">
                <button type="button" class="button button--secondary" data-prod_id="${frenzy_var_id[0]}" data-handle="${data?.org_prod_url}" data-id="${frenzy_var_id[1]}" data-sku="${frenzy_sku}" data-config_id="${frenzy_configID}" data-name="${frenzy_event_name}" data-request_id="${frenzy_request_ID}" tabindex="0">QUICK VIEW</button>
              </div>`
    html.querySelector('.frenzy_product_item').insertAdjacentHTML("afterEnd",quickviewbtn_html);
  }
}

function FrenzyswatchQuery(productID, productCard) {
  let currentProductId = 1;

  if (productID == currentProductId) {
    return;
  }

  const base64ProductId = window.btoa("gid://shopify/Product/" + productID);
  const productSwatchQuery = `{
    node(id:"${base64ProductId}"){
      ... on Product {
        id
        title
        onlineStoreUrl
        handle
        images(first: 2) {
          edges {
            node {
              originalSrc
            }
          }
        }
        priceRange {
          maxVariantPrice {
            amount
          }
          minVariantPrice {
            amount
          }
        }
        variants(first: 50) {
          edges {
            node {
              id
              availableForSale
              price {
              amount
            }
            compareAtPrice {
              amount
            }
            }
          }
        }
      }
    }
  }`;

  $.ajax({
    url: "https://adrianna-papell-usd.myshopify.com/api/2023-07/graphql.json",
    headers: {
      "X-Shopify-Storefront-Access-Token": "d0d792a115cdb79263125f3b70322bfe",
      "Content-Type": "application/graphql",
    },
    type: "POST",
    data: productSwatchQuery,
  })
  .done(function(result) {
    frenzyswatchProductSwap(result, productCard, productID);
    frenzyCartSwatchSetProductHandle(result, productCard, productID)
  })
  .fail(function(result, textStatus) {
    console.log("Request failed: " + textStatus);
  });
}
function frenzyCartSwatchSetProductHandle(prod,prodCard,prodtID){
  if(prod?.data?.node != null){
    const firstAvailable = prod.data.node.variants.edges.find(edge => edge.node.availableForSale === true);
    if(firstAvailable){
      const getVid = firstAvailable.node.id.replace('gid://shopify/ProductVariant/','');
      const getPid = prod.data.node.id.replace('gid://shopify/Product/','');
      const prodSku = getPid + '_' + getVid;
      prodCard.querySelector('.quick_view_cart button')?.setAttribute('data-handle',prod.data.node.handle);
      prodCard.querySelector('.quick_view_cart button')?.setAttribute('data-id',getVid);
      prodCard.querySelector('.quick_view_cart button')?.setAttribute('data-sku',prodSku);
    }
  }
}
function frenzyswatchProductSwap(product,productCard,productID) {
  if(product?.data?.node != null){
  var elem = productCard.querySelector('.frenzy_img_first');
  var src = product.data.node.images.edges[0].node.originalSrc.replace('.jpg?','_500x.jpg?');
  productCard.querySelector('.frenzy_product_title a').innerText = product.data.node.title;
  // productCard.find('.product-card__title a').attr('title',product.data.node.title);
  productCard.querySelector('.frenzy_product_title a').setAttribute('href','/products/' + product.data.node.handle);
  productCard.querySelector('figure a').setAttribute('href','/products/' + product.data.node.handle);
  // productCard.find('.grid-view-item__link').attr('title', product.data.node.title);
  // productCard.find('.grid-view-item__link').attr('href','/products/' + product.data.node.handle);
  // productCard.find('.data-item-image').attr('alt', product.data.node.title);
  var min_variant_price = 9999;
  var max_variant_price = 0;
  var min_variant_compareAtPrice = 9999;
  var max_variant_compareAtPrice = 0;
  var variants_data = product.data.node.variants.edges;
  for (var k in variants_data) {
    var variant_price = Number(variants_data[k].node.price.amount);
    if(variants_data[k].node.compareAtPrice){
    var variant_compareAtPrice = Number(variants_data[k].node.compareAtPrice.amount);
    }
    else{
      variant_compareAtPrice = 0;
    }
    if (variant_price < min_variant_price) {
      min_variant_price = variant_price;
    }

    if (variant_price > max_variant_price) {
      max_variant_price = variant_price;
    }

    if (variant_compareAtPrice < min_variant_compareAtPrice && variant_compareAtPrice != 0) {
      min_variant_compareAtPrice = variant_compareAtPrice;
    }

    if (variant_compareAtPrice > max_variant_compareAtPrice && variant_compareAtPrice != 0) {
      max_variant_compareAtPrice = variant_compareAtPrice;
    }

  }
  //if variant sale prices varies or varint compareAtPrice varies add 'From' text
  if ((min_variant_price != max_variant_price && min_variant_compareAtPrice != max_variant_compareAtPrice && min_variant_compareAtPrice != 9999) ||
    (min_variant_price == max_variant_price && min_variant_compareAtPrice != max_variant_compareAtPrice && min_variant_compareAtPrice != 9999)) {
    // productCard.find('.price--listing').addClass('price--on-sale').removeClass('price--compare-price-hidden');
    productCard.querySelector('.frenzy_product_price_sale').innerText = 'From $' + min_variant_price.toFixed(2).replace('.00', '');
    productCard.querySelector('.frenzy_product_price_compare').innerText ='$' + min_variant_compareAtPrice.toFixed(2).replace('.00', '');
    productCard.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
  }
  //if it has a variant on sale
  else if (min_variant_price == max_variant_price && min_variant_compareAtPrice == max_variant_compareAtPrice && min_variant_price != max_variant_compareAtPrice) {
    // productCard.find('.price--listing').addClass('price--on-sale').removeClass('price--compare-price-hidden');
    productCard.querySelector('.frenzy_product_price_sale').innerText = '$' + min_variant_price.toFixed(2).replace('.00', '');
    productCard.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
    productCard.querySelector('.frenzy_product_price_compare').innerText = '$' + min_variant_compareAtPrice.toFixed(2).replace('.00', '');
  }
  //if not on sale but variant prices varies
  else if (min_variant_price != max_variant_price) {
    // productCard.find('.price--listing').removeClass('price--on-sale').addClass('price--compare-price-hidden');
    productCard.querySelector('.frenzy_product_price_sale').classList.remove('is-sale');
    productCard.querySelector('.frenzy_product_price_sale').innerText  = 'From $' + min_variant_price.toFixed(2).replace('.00', '');
  } else {
    // productCard.querySelector('.price--listing').removeClass('price--on-sale');
    productCard.querySelector('.frenzy_product_price_sale').classList.remove('is-sale');
    productCard.querySelector('.frenzy_product_price_sale').innerTex = '$' + min_variant_price.toFixed(2).replace('.00', '');
  }
  //update image
  productCard.querySelector('.frenzy_img');
  // productCard.find('.btn--quickview').attr('data-product-id',productID);
    frenzyswapImage(elem, src);
    var eleme = productCard.querySelector('.frenzy_img_second');
   var srcc = product.data.node.images.edges[1].node.originalSrc.replace('.jpg?','_500x.jpg?');
   frenzyswapImage(eleme, srcc);
  }
}
function frenzyswapImage(elem, src) {
  elem.classList.remove('lazyautosizes');
  elem.classList.remove('lazyloaded');
  elem.removeAttribute('data-srcset');
  elem.removeAttribute('srcset');
  // elem.closest('.product-card').querySelector('.placeholder-background').classList.remove('hide');
  elem.setAttribute('data-src', src);
  elem.classList.add('lazyload');
}

function frenzy_recommendation_loaded(products) {
  const frenzyOutofstockSection = document.querySelector('.frenzy_outofstock_section');
  if(frenzyOutofstockSection){
  const selected_variant = frenzyOutofstockSection.getAttribute('data-selected-variant');
  const filteredOption = (products.options || []).find(option => option.name == 'size');
    if(filteredOption){
      const filteredSize = filteredOption.data;
      const filteredRequiredSize = filteredSize?.find(variant => variant.label == selected_variant);
      const variantID = filteredRequiredSize?.variant_id;
      const getDetails = products.sku.split('_');
          getDetails[1] = String(variantID);
      const newSKU = getDetails.join("_");
      frenzyOutofstockSection.querySelectorAll('.frenzy_product_item[data-product_id="'+products.product_id+'"]').forEach(function(card) {
        card.setAttribute('data-id', newSKU);
        card.querySelector('figure a').setAttribute('data-sku', newSKU);
        card.querySelector('.frenzy_quickView_btn').setAttribute('data-sku', newSKU);
        card.querySelector('.frenzy_product_buttom .frenzy_add_to_cart_btn').setAttribute('data-sku', newSKU);
        if(filteredRequiredSize.stock_amount < 1){
          card.querySelector('.frenzy_product_buttom .frenzy_add_to_cart_btn').innerHTML = 'Sold Out';
          card.querySelector('.frenzy_product_buttom .frenzy_add_to_cart_btn').setAttribute('disabled','');
        }
      });
    }
  }
}

window.frenzyoutofStockCallback = function(currentVariant){
  let elements = document.querySelectorAll('.frenzy_recommendation_section');
  elements = Array.from(elements);
  let self = elements.find(element => element.classList.contains('frenzy_outofstock_section'));
  if(currentVariant.available != true){
  const frenzyApiName = __st.p === "product" ? "similar_product_carousel" : "personalized_homepage_carosuel";
  let newIndex = 1;
  if(elements.length == 1){
    newIndex = 2;
  }else if(elements.length > 1){
    newIndex = (elements.length + 1);
  }
  const swiperContainerClass = frenzyApiName+'-'+newIndex;
  let product_id_Frenzy = __st.p === "product" ? __st.rid : "";
  let variant_id_Frenzy = "";

  const re_div = '<h2 class="product-single__title_2">Available In Size '+currentVariant?.option3+'</h2> <div class="frenzy_recommendation_section frenzy_outofstock_section '+swiperContainerClass+'" config_id="faecb8e7-963c-4856-8803-39d21f7b7506"></div>';
  document.querySelector('.frenzy_extra_outofstock_section').innerHTML = re_div;
  let new_self = document.querySelector('.frenzy_extra_outofstock_section').querySelector('.frenzy_outofstock_section');
  new_self.setAttribute('data-selected-variant', currentVariant?.option3);
  new_self.setAttribute('data-variantID', currentVariant?.id);
  if (new_self.getAttribute('data-variantID')) {
    variant_id_Frenzy = new_self.getAttribute('data-variantID');
  }
  if (product_id_Frenzy && variant_id_Frenzy) {
    frenzy_sku = product_id_Frenzy + "_" + variant_id_Frenzy;
  }
  const frenzy_recommendation_section_config = new_self.getAttribute("config_id") ? new_self.getAttribute("config_id") : null;
  const frenzy_product_details_section_ABTest_id = new_self.getAttribute("data-ab_test_id") ? self.getAttribute("data-ab_test_id") : null;
  var data_json = JSON.stringify({
        sku: frenzy_sku,
        user_id: user_id_Frenzy != '' ? user_id_Frenzy?.toString() : null,
        page: __st.p,
        shop: Shopify.shop,
        num_matching: 15,
        full_description: true,
        config_id: frenzy_recommendation_section_config,
        ab_test_id: frenzy_product_details_section_ABTest_id,
        currency: Shopify?.currency?.active ? Shopify?.currency?.active : '',
        country: Shopify.country ? Shopify.country : '',
        state: frenzy_state ? frenzy_state : null,
        company_id: frenzy_company_id ? frenzy_company_id : null,
        location_id: frenzy_location_id ? frenzy_location_id : null,
        session_id: frenzy_session_id ? frenzy_session_id : null
    });
  var classList = '';
   new_self.classList.forEach(function(classname, index){
      if (index == 0) {
        classList += classname;
      } else {
        classList += '.' + classname;
      }
    });
    getRecommendationAPIWithStructure(data_json, '/recommendation', new_self,frenzyApiName,newIndex);
    //getRecommendationAPIWithStructure(data_json, '/recommendation', classList,frenzyApiName);
    setTimeout(function(){
       var outOfStockSections = document.querySelectorAll('.frenzy_extra_outofstock_section');
        outOfStockSections.forEach(function(section) {
            var recommendationItems = section.querySelector('.recommendation_product_items');
            if (recommendationItems && recommendationItems.children.length === 0) {
                section.style.display = 'none';
            }
        });
    });
  }else{
    document.querySelector('.frenzy_extra_outofstock_section').innerHTML= '';
  }
}

var collection__handle = '';
if( document.querySelector('.frenzy_collections_page')){
  collection__handle = document.querySelector('.frenzy_collections_page').getAttribute('data-handle');
}
function sortByChange(){
  if(collection__handle == 'new-arrivals' || collection__handle == 'prom-dresses' || collection__handle == 'adrianna-prom-dresses'){
    var sort_selected_status = false;
    if(document.querySelector('#frenzy_sort-list')){
      document.querySelectorAll('#frenzy_sort-list li').forEach(function(this_click){
        if(this_click.querySelector('.frenzy_popout-list__option').getAttribute('data-value') == 'best match' && this_click.querySelector('.frenzy_popout-list__option').classList.contains('frenzy_popout-list__item--current')){
          sort_selected_status = true;
        }
        if(this_click.querySelector('.frenzy_popout-list__option').getAttribute('data-value') == 'newest'){
          this_click.style.order = '-1';
        }
        if(sort_selected_status && this_click.querySelector('.frenzy_popout-list__option').getAttribute('data-value') == 'newest'){
            this_click.querySelector('.frenzy_popout-list__option').classList.add('frenzy_popout-list__item--current');
            document.querySelector('.frenzy_sort-heading-desktop').innerHTML = this_click.querySelector('.frenzy_popout-list__option span').innerHTML;
            this_click.style.order = '-1';
        }
        if(this_click.querySelector('.frenzy_popout-list__option').getAttribute('data-value') == 'best match'){
          this_click.remove();
        }
      });
    }
  }
  const frenzyFilterOpen = document.querySelector('.frenzy_flex_topbar_filter_col') ? document.querySelector('.frenzy_flex_topbar_filter_col').querySelectorAll('.filter_widget_trigger.is-open') : [];
  if(frenzyFilterOpen.length === 0){
     document.querySelector('.frenzy_flex_topbar_filter_col') ? document.querySelector('.frenzy_flex_topbar_filter_col').querySelector('.filter_type_s_size .filter_widget_trigger').click() : ''; 
  }
}
        
function filterTagUpdate(){
  const h3Elements = document.querySelectorAll('.frenzy_sidebar_header h3');
  h3Elements.forEach(h3 => {
    const newP = document.createElement('p');
    newP.innerHTML = h3.innerHTML;
    h3.parentNode.replaceChild(newP, h3);
  });
  const h2Elements = document.querySelectorAll('.frenzy_popout--navbar h2');
  h2Elements.forEach(h2 => {
    const newP = document.createElement('p');
    newP.innerHTML = h2.innerHTML;
    newP.setAttribute('class','visually-hidden');
    newP.setAttribute('id','frenzy_sort-heading')
    h2.parentNode.replaceChild(newP, h2);
  });
}
window.frenzAfterApiCallBack = function(){
  filterTagUpdate();
  sortByChange();
}
   
window.frenzyCartCallBack = function(){
  if(__st.p == 'cart'){
     window.location.reload();
  }else{
    document.querySelector('body').classList.add('cart-sidebar-show');
    Shopify.getCart((cart) => {
    // halo.updateSidebarCart(cart);
    });
  }
}

window.frenzyProductGridWidgetCallBack = function(){
  const getHHTML =  document.querySelector('#frenzy_product_grid_widget');
  return getHHTML.innerHTML;
}

document.addEventListener("DOMContentLoaded", (event) => {
  if(window.innerWidth > 1200){
    const getFrenzyInputs = document.querySelectorAll('input.frenzy_search_suggest');
    getFrenzyInputs.forEach((inputEl) => {
      inputEl.addEventListener("focus", (event) => {
        const parentForm = event.target.closest('form');
        const nextEl = parentForm?.nextElementSibling;
        console.log(nextEl);
        if (nextEl && nextEl.matches('.frenzy-suggest-wrapper')) {
          nextEl.classList.add('open');
          nextEl.style.setProperty('display', 'block');
        }
      });
    });
    document.body.addEventListener('click', (e) => {
    if (e.target.closest('input.frenzy_search_suggest') || e.target.closest('.frenzy-suggest-wrapper.open')) {
      return;
    }
    document.querySelectorAll('.frenzy-suggest-wrapper.open').forEach((el) => {
        el.classList.remove('open');
        el.style.setProperty('display', 'none');
    });
    });
  }
});
document.querySelector('.header__icon.cstm_updated_search').addEventListener('click', ()=>{
  document.querySelector('sticky-header .frenzy-suggest-wrapper').style.setProperty('display', 'block');
});
document.addEventListener('click', (event)=>{
  const getSearchAttribute = document.querySelector('sticky-header .cstm__new_search_box.header__iconItem.header__search')?.getAttribute('style');
  if(!event?.target?.closest('.wrapper-header-bottom') && getSearchAttribute === ''){
    document.querySelector('sticky-header .wrapper-header-bottom .header-search-close-update')?.dispatchEvent(new MouseEvent('click',{bubbles:true}));
  }
});
document.querySelector('.header-mobile__item.header-mobile__item--search').addEventListener('click', ()=>{
  document.querySelector('.frenzy_mobile_search')?.classList?.remove('hidden');
  const inputMobile = document.querySelector('.frenzy_mobile_search_box .frenzy_search_suggest');
  if(inputMobile){
    setTimeout(()=>{
      inputMobile.focus();
      inputMobile.click();
      inputMobile.dispatchEvent(new KeyboardEvent('input', {bubbles:true}))
    },100)
  }
});

